import { render, staticRenderFns } from "./CActiveListItem.vue?vue&type=template&id=0238a172&"
import script from "./CActiveListItem.vue?vue&type=script&lang=ts&"
export * from "./CActiveListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports